import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/workspace")({
  head: () => ({ meta: [{ title: "Workspace · CARIO INTEL" }] }),
  component: () => <Navigate to="/investigate" />,
});